import React from "react";
import { useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import "./UserLogout.css";

function UserLogout({ onClose }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear local storage
    localStorage.removeItem("token");   // 👈 yahi remove karna hai
    localStorage.removeItem("userId");

    // Navigate to login
    navigate("/user/login", { replace: true });
  };

  const handleCancel = () => {
    if (onClose) onClose();
  };

  return (
    <div className="logout-overlay">
      <div className="logout-box">
        <h2 className="logout-title">Logout</h2>
        <p className="logout-text">Are you sure you want to logout?</p>
        <div className="logout-buttons">
          <button className="admin-cancel-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button className="admin-logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserLogout;
